import { useContext } from "react";
import SearchPageLayoutContext, { DEFAULT_STATE } from "views/components/contexts/SearchPageLayoutContext";
export default function useSearchPageLayout() {
  let context = useContext(SearchPageLayoutContext);
  if (context === void 0) {
    context = DEFAULT_STATE;
  }
  return context;
}
